import React, {PropTypes} from 'react';
import OrderRow from './order-row';

export class RegisteredOrdersTable extends React.Component {

  static propTypes = {
    invoices: PropTypes.array.isRequired,
    removeInvoiceFromState: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      showMoreList: {
        invoiceId: null,
        show: false
      }
    };

    this.setShowMoreList = this.setShowMoreList.bind(this);
    this.resetShowMoreList = this.resetShowMoreList.bind(this);
    this.renderOrderRows = this.renderOrderRows.bind(this);
    this.removeInvoiceFromState = this.removeInvoiceFromState.bind(this);
  }

  setShowMoreList (invoiceId) {
    const invoiceIdSet = this.state.showMoreList.invoiceId === invoiceId;
    this.setState({
      showMoreList: {
        invoiceId: invoiceIdSet ? null : invoiceId,
        show: !invoiceIdSet
      }
    });
  };

  resetShowMoreList () {
    this.setState({
      showMoreList: {
        invoiceId: null,
        show: false
      }
    });
  }

  removeInvoiceFromState (invoiceId) {
    this.setState({
      showMoreList: {
        invoiceId: null,
        show: false
      }
    });
    this.props.removeInvoiceFromState(invoiceId);
  }

  renderOrderRows () {
    let orderRows = [];

    this.props.invoices.forEach((invoice) => {
      orderRows.push(
        <OrderRow
          key={invoice.id}
          invoice={invoice}
          user={this.props.user}
          removeInvoiceFromState={this.removeInvoiceFromState}
          toggleShowMoreList={this.setShowMoreList}
          resetShowMoreList={this.resetShowMoreList}
          showMoreList={this.state.showMoreList}
        />
      );
    });

    return orderRows;
  }

  render () {
    return (
      <div className='registered-orders-table'>
        {this.renderOrderRows()}
      </div>
    );
  }
}

export default RegisteredOrdersTable;



/** WEBPACK FOOTER **
 ** ./src/components/registered-orders/registered-orders-table.js
 **/